import { PaymentMethodEnum } from 'api';
import { SelectField, SelectFieldProps, SelectOption } from 'form';
import { translate } from 'i18n';

type Props = Omit<SelectFieldProps, 'options' | 'label' | 'name'> & {
  required?: boolean;
  label?: string;
  name?: string;
};

const PAYMENT_METHOD_OPTIONS: SelectOption[] = [
  {
    label: translate('backlog.paymentMethod.options.documentAgainstPayment', { namespace: 'features' }),
    value: PaymentMethodEnum.DP,
  },
  {
    label: translate('backlog.paymentMethod.options.telegraphicTransfer', { namespace: 'features' }),
    value: PaymentMethodEnum.TT,
  },
];

export const PaymentMethod = ({
  label = translate('backlog.paymentMethod.label', { namespace: 'features' }),
  name = 'payment_method',
  required = true,
  ...rest
}: Props) => {
  return <SelectField label={label} name={name} options={PAYMENT_METHOD_OPTIONS} required={required} {...rest} />;
};
